<template>

    <div id="settings-menu" v-display-none="dataStore.showOptionMenu">

        <ul class="nav nav-tabs">

            <li class="nav-item" :class="{ active: 'filter' === activeItem}">
                <a @click.prevent="selectItem('filter')" :class="{ active: 'filter' === activeItem}" class="nav-link" href="#" :title="language.filter" >{{ language.filter }}</a>
            </li>

            <li class="nav-item" :class="{ active: 'stats' === activeItem}">
                <a @click.prevent="selectItem('stats')" :class="{ active: 'stats' === activeItem}" class="nav-link" href="#" :title="language.statistics" >{{ language.statistics }}</a>
            </li>

            <span class="close-popup" v-on:click="toggleOptionMenu()" :name="language.close_analysis"><i class="fas fa-times"></i></span>

        </ul>

        <div class="container">

            <div class="row">

                <div class="col-12">

                    <div class="row" :class="{ 'is-question' : (dataStore.currentSlide && dataStore.currentSlide.type === 'question')}">

                        <div class="col-12 chart-wrapper" v-if="activeItem !== 'filter' && (dataStore.currentSlide.allow_good_options && dataStore.currentSlide.allow_bad_options) && dataStore.currentSlide.question.type === 'goodbad'">
                            <legend class="legend-filter">{{ allowedLabelsProject(project.slug) ? 'Bra/Mindre bra' : language.good_bad }}</legend>
                            <chart class="chart-dialog" :key="componentKey" ref="chart" id="good_bad-chart" :project="project" :item="dataStore.currentSlide" :slug="'good_bad'"></chart>
                        </div>

                        <div class="col-12" v-if=" dataStore.currentSlide && dataStore.currentSlide.allow_good_options && dataStore.currentSlide.question && dataStore.currentSlide.question.type === 'goodbad'">

                            <div v-if="activeItem === 'filter'" class="filter" :class="allowedLabelsProject(project.slug) ? 'not-show' : ''">

                                <div class="legend-and-check form-check" :class="{'both-good-and-bad' : dataStore.currentSlide.allow_good_options && dataStore.currentSlide.allow_bad_options}">

                                    <input v-if="dataStore.currentSlide.allow_good_options && dataStore.currentSlide.allow_bad_options" title="Bra" id="good-filter" class="form-check-input before-legend" v-model="dataStore.selectedFilters" :value="{'value' : 'good', 'type' : 'good_bad'}" v-on:change="runFilter" type="checkbox">

                                    <legend class="legend-filter">{{ language.good }} <img :alt="language.good" src="/images/pin_bra.png" /></legend>

                                </div>

                                <div v-if="!allowedLabelsProject(project.slug)">

                                    <div v-for="(goodVal, gdTypes) in goodOptions" :key="`type-${gdTypes}-gd`" class="form-check">

                                        <input class="form-check-input" type="checkbox" :title="goodVal.value" v-model="dataStore.selectedFilters" :value="{'value' : goodVal.id, 'type' : 'quality'}" v-on:change="runFilter" :id="`type-filter-${convertToSlug(goodVal.value)}`">

                                        <label class="form-check-label" :for="`type-filter-${convertToSlug(goodVal.value)}`">
                                            {{ goodVal.value }}
                                        </label>

                                    </div>

                                </div>

                            </div>

                            <div v-else >

                                <div v-if="dataStore.currentSlide && dataStore.currentSlide.question && dataStore.currentSlide.question.options.length > 0" class="col-12 chart-wrapper">

                                    <legend v-if="!allowedLabelsProject(project.slug)" class="legend-filter">{{ language.good }}</legend>

                                    <chart class="chart-dialog" v-if="!allowedLabelsProject(project.slug)" :key="componentKey" ref="chart" id="good_types-chart" :project="project" :item="dataStore.currentSlide" :slug="'good_types'"></chart>

                                </div>

                            </div>

                        </div>

                        <div class="col-12" v-if="dataStore.currentSlide && dataStore.currentSlide.allow_bad_options && dataStore.currentSlide.question && dataStore.currentSlide.question.type === 'goodbad'">

                            <div class="filter" :class="allowedLabelsProject(project.slug) ? 'not-show' : ''" v-if="activeItem === 'filter'">

                                <div class="legend-and-check form-check" :class="{'both-good-and-bad' : dataStore.currentSlide.allow_good_options && dataStore.currentSlide.allow_bad_options}">

                                    <input v-if="dataStore.currentSlide.allow_good_options && dataStore.currentSlide.allow_bad_options" :title="allowedLabelsProject(project.slug) ? 'Mindre bra' : 'Förbättra'" id="bad-filter" class="form-check-input before-legend" v-model="dataStore.selectedFilters" :value="{'value' : 'bad', 'type' : 'good_bad'}" v-on:change="runFilter" type="checkbox">

                                    <legend class="legend-filter">{{ allowedLabelsProject(project.slug) ? 'Mindre bra' : language.improve }} <img :alt="allowedLabelsProject(project.slug) ? 'Mindre bra' : language.improve" src="/images/pin_forbattra.png" /></legend>

                                </div>

                                <div v-if="!allowedLabelsProject(project.slug)">

                                    <div v-for="(badVal, bdTypes) in badOptions" :key="`type-${bdTypes}-bd`" class="form-check">

                                        <input class="form-check-input" :title="badVal.value" type="checkbox" v-model="dataStore.selectedFilters" :value="{'value' : badVal.id, 'type' : 'quality'}" v-on:change="runFilter" :id="`type-filter-${convertToSlug(badVal.value)}`">

                                        <label class="form-check-label" :for="`type-filter-${convertToSlug(badVal.value)}`">
                                            {{ badVal.value }}
                                        </label>

                                    </div>

                                </div>

                            </div>

                            <div v-else >

                                <div v-if="dataStore.currentSlide && dataStore.currentSlide.question && dataStore.currentSlide.question.options.length > 0" class="col-12 chart-wrapper">

                                    <legend v-if="!allowedLabelsProject(project.slug)" class="legend-filter">{{ allowedLabelsProject(project.slug) ? 'Mindre bra' : language.improve }}</legend>

                                    <chart class="chart-dialog" v-if="!allowedLabelsProject(project.slug)" :key="componentKey" ref="chart" id="bad_types-chart" :project="project" :item="dataStore.currentSlide" :slug="'bad_types'"></chart>

                                </div>

                            </div>

                        </div>

                    </div>

                    <div v-if="activeItem === 'filter' && dataStore.currentSlide && dataStore.currentSlide.question && dataStore.currentSlide.question.allow_upload_image" class="row">

                        <div class="col-12 filter">
                            <div class="legend-and-check form-check show-image-filter">
                                <input class="form-check-input before-legend" :title="language.only_with_images" v-model="dataStore.selectedFilters" :value="{'value' : true, 'type' : 'only_images'}" v-on:change="runFilter" type="checkbox"><legend class="legend-filter">{{ language.only_with_images }}</legend>
                            </div>
                        </div>

                    </div>

                    <div class="row" v-if="project.hide_ages && project.ages.length > 0">

                        <div class="col-12 filter" v-if="activeItem === 'filter'">

                            <legend class="legend-filter">{{ language.age }}</legend>

                            <div v-for="(ageVal, indexAges) in project.ages" :key="`age-${indexAges}`" class="form-check">

                                <input class="form-check-input" :title="'Ålder: ' + ageVal.age" v-model="dataStore.selectedFilters" :value="{'value' : ageVal.age, 'type' : 'age'}" v-on:change="runFilter" type="checkbox"  :id="`age-filter-${convertToSlug(ageVal.age)}`">

                                <label class="form-check-label" :for="`age-filter-${convertToSlug(ageVal.age)}`">
                                    {{ ageVal.age }}
                                </label>

                            </div>

                        </div>

                        <div class="col-12 chart-wrapper" v-else >

                            <legend class="legend-filter">{{ language.age }}</legend>

                            <chart class="chart-dialog" :key="componentKey" ref="chart" id="age-chart" :project="project" :item="dataStore.currentSlide" :slug="'ages'"></chart>

                        </div>
                    </div>

                    <div class="row" v-if="project.hide_types && project.types.length > 0">

                        <div class="col-12 filter" v-if="activeItem === 'filter'">

                            <legend class="legend-filter">{{ language.type }}</legend>

                            <div v-for="(typeVal, indexTypes) in project.types" :key="`type-${indexTypes}`" class="form-check">

                                <input class="form-check-input" :title="'Grupp: ' + typeVal.type"  type="checkbox" v-model="dataStore.selectedFilters" :value="{'value' : typeVal.type, 'type' : 'type'}" v-on:change="runFilter" :id="`type-filter-${convertToSlug(typeVal.type)}`">

                                <label class="form-check-label" :for="`type-filter-${convertToSlug(typeVal.type)}`">
                                    {{ typeVal.type }}
                                </label>

                            </div>

                        </div>

                        <div class="col-12 chart-wrapper" v-else >

                            <legend class="legend-filter">{{ language.type }}</legend>

                            <chart class="chart-dialog" :key="componentKey" ref="chart" id="type-chart" :project="project" :item="dataStore.currentSlide" :slug="'types'"></chart>

                        </div>

                    </div>

                    <div class="row" v-if="project.hide_sex">

                        <div class="col-12 filter" v-if="activeItem === 'filter'">

                            <legend class="legend-filter">{{ language.gender }}</legend>

                            <div v-if="!project.genders.length" class="form-check">

                                <input class="form-check-input" :title="language.female" type="checkbox" v-model="dataStore.selectedFilters" :value="{'value' : 'Kvinna', 'type' : 'sex'}" v-on:change="runFilter" id="sex-filter-woman">

                                <label class="form-check-label" for="sex-filter-woman">
                                    {{ language.female }}
                                </label>

                            </div>

                            <div v-if="!project.genders.length" class="form-check">

                                <input class="form-check-input" :title="language.male" type="checkbox" v-model="dataStore.selectedFilters" :value="{'value' : 'Man', 'type' : 'sex'}" v-on:change="runFilter" id="sex-filter-man">

                                <label class="form-check-label" for="sex-filter-man">
                                    {{ language.male }}
                                </label>

                            </div>

                            <div v-if="!project.genders.length" class="form-check">

                                <input class="form-check-input" :title="language.other" type="checkbox" v-model="dataStore.selectedFilters" :value="{'value' : 'Annan', 'type' : 'sex'}" v-on:change="runFilter" id="sex-filter-other">

                                <label class="form-check-label" for="sex-filter-other">
                                    {{ language.other }}
                                </label>

                            </div>

                            <div v-if="project.genders.length" v-for="(gender, genderIndex) in project.genders" :key="`gender-${genderIndex}`" class="form-check">

                                <input class="form-check-input" :title="'Kön: ' + gender.gender" type="checkbox" v-model="dataStore.selectedFilters" :value="{'value' : gender.gender, 'type' : 'sex'}" v-on:change="runFilter" :id="`type-filter-${convertToSlug(gender.gender)}`">

                                <label class="form-check-label" :for="`type-filter-${convertToSlug(gender.gender)}`">
                                    {{ gender.gender }}
                                </label>

                            </div>

                        </div>

                        <div class="col-12 chart-wrapper" v-else >

                            <legend class="legend-filter">{{ language.gender }}</legend>

                            <chart class="chart-dialog" :key="componentKey" ref="chart" id="county-chart" :project="project" :item="dataStore.currentSlide" :slug="'genders'"></chart>

                        </div>

                    </div>

                    <div class="row" v-if="project.hide_counties && project.counties.length > 0">

                        <div class="col-12 filter" v-if="activeItem === 'filter'">

                            <legend class="legend-filter">{{ language.county }}</legend>

                            <div v-for="(county, countyIndex) in project.counties" :key="`county-${countyIndex}`" class="form-check">

                                <input class="form-check-input" :title="'Område: ' + county.name" type="checkbox" v-model="dataStore.selectedFilters" :value="{'value' : county.name, 'type' : 'county'}" v-on:change="runFilter" :id="`type-filter-${convertToSlug(county.name)}`">

                                <label class="form-check-label" :for="`type-filter-${convertToSlug(county.name)}`">
                                    {{ county.name }}
                                </label>

                            </div>

                        </div>

                        <div class="col-12 chart-wrapper" v-else >

                            <legend class="legend-filter">{{ language.county }}</legend>

                            <chart class="chart-dialog" :key="componentKey" ref="chart" id="county-chart" :project="project" :item="dataStore.currentSlide" :slug="'counties'"></chart>

                        </div>

                    </div>

                    <div class="row" v-if="dataStore.currentSlide && dataStore.currentSlide.question.type === 'scale'">

                        <div class="col-12 filter" v-if="activeItem === 'filter'">

                            <legend class="legend-filter">{{ dataStore.currentSlide.question.description }}</legend>

                            <div v-if="dataStore.currentSlide.question.options.length === 0" class="form-check">

                                <input class="form-check-input" :title="language.strongly_disagree" type="checkbox" v-model="dataStore.selectedFilters" :value="{'value' : 1001, 'type' : 'scale'}" v-on:change="runFilter" id="scale-filter-1">

                                <label class="form-check-label" for="scale-filter-1">
                                    {{ language.strongly_disagree }}
                                </label>

                            </div>

                            <div v-if="dataStore.currentSlide.question.options.length === 0" class="form-check">

                                <input class="form-check-input" :title="language.disagree" type="checkbox" v-model="dataStore.selectedFilters" :value="{'value' : 1002, 'type' : 'scale'}" v-on:change="runFilter" id="scale-filter-2">

                                <label class="form-check-label" for="scale-filter-2">
                                    {{ language.disagree }}
                                </label>

                            </div>

                            <div v-if="dataStore.currentSlide.question.options.length === 0" class="form-check">

                                <input class="form-check-input" :title="language.neither" type="checkbox" v-model="dataStore.selectedFilters" :value="{'value' : 1003, 'type' : 'scale'}" v-on:change="runFilter" id="scale-filter-3">

                                <label class="form-check-label" for="scale-filter-3">
                                    {{ language.neither }}
                                </label>

                            </div>

                            <div v-if="dataStore.currentSlide.question.options.length === 0" class="form-check">

                                <input class="form-check-input" :title="language.partially_agree" type="checkbox" v-model="dataStore.selectedFilters" :value="{'value' : 1004, 'type' : 'scale'}" v-on:change="runFilter" id="scale-filter-4">

                                <label class="form-check-label" for="scale-filter-4">
                                    {{ language.partially_agree }}
                                </label>

                            </div>

                            <div v-if="dataStore.currentSlide.question.options.length === 0" class="form-check">

                                <input class="form-check-input" :title="language.fully_agree" type="checkbox" v-model="dataStore.selectedFilters" :value="{'value' : 1005, 'type' : 'scale'}" v-on:change="runFilter" id="scale-filter-5">

                                <label class="form-check-label" for="scale-filter-5">
                                    {{ language.fully_agree }}
                                </label>

                            </div>

                            <div v-if="dataStore.currentSlide.question.options.length > 0">

                                <div v-for="(option) in dataStore.currentSlide.question.options" :key="option.id" class="form-check">

                                    <input class="form-check-input" :title="option.value" type="checkbox" v-model="dataStore.selectedFilters" :value="{'value' : option.id, 'type' : 'scale'}" v-on:change="runFilter" :id="`scale-filter-${convertToSlug(option.id)}`">

                                    <label class="form-check-label" :for="`scale-filter-${convertToSlug(option.id)}`">
                                        {{ option.value }}
                                    </label>

                                </div>

                            </div>

                        </div>

                        <!-- <div class="col-12 chart-wrapper" v-else>
                            <legend class="legend-filter">{{ dataStore.currentSlide.question.description }}</legend>
                            <chart class="chart-dialog" :key="componentKey" ref="chart" id="scale-chart" :project="project" :item="dataStore.currentSlide" :slug="'scales'"></chart>
                        </div> -->

                    </div>

                </div>

            </div>

        </div>

    </div>

</template>

<script>


import dataStore from "../store"

import Chart from "./Chart"

import { allowedLabelsProject, applyFilters, toggleSettingsMenu } from './../functions'

export default {

    components: {
        Chart
    },

    inject: [ 'language' ],

    data() {
        return {
            dataStore,
            activeItem: 'filter',
            allowedLabelsProject,
            debounce : null,
            debounceTimer : 500
        };
    },

    props: {
        project : Object,
        componentKey : Number,
    },

    computed: {

        goodOptions : function () {

            return this.dataStore.currentSlide && this.dataStore.currentSlide.question.options.filter((v) => {
                if(v.type === 'good'){
                    return v.value
                }
            })
        },

        badOptions : function () {

            return this.dataStore.currentSlide && this.dataStore.currentSlide.question.options.filter((v) => {
                if(v.type === 'bad'){
                    return v.value
                }
            })
        }
    },

    methods: {

        toggleOptionMenu: function() {
            toggleSettingsMenu()
        },

        runFilter: function() {

            clearTimeout(this.debounce)

            this.debounce = setTimeout(() => {

                return applyFilters();

            }, this.debounceTimer)



        },

        selectItem(type) {
            this.activeItem = type;
            document.querySelector('#settings-menu').scrollTo(0,0);
        },

        convertToSlug: function(text) {
            if (!(typeof text === 'string' || text instanceof String)) return;
            return text.toLowerCase()
                    .replace(/ /g, '-')
                    .replace(/[^\w-]+/g, '');
        }

    }
};
</script>

